import { FormControlLabel, Grid, Switch } from "@mui/material";
import { FastField } from "formik";
import {
  MySelect,
  MySelectTime,
  MyTextField,
  MyTextFieldArea,
  MyTextFieldUploadFile,
  UploadAnhDaiDien,
  UploadMultiFile,
  UploadMultiHinhAnh
} from "../Lib/componentLibrarys";
import Api from "../../api2";
import { useEffect, useState } from "react";
import { isEmpty } from "lodash";
import { UploadMultiFile as UploadMultiFiles } from "../DanhMuc/Components";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

export const FormNhap = ({
  values,
  errors,
  setFieldValue,
  danhMucSanPhamList
}) => {
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      [{ font: [] }],
      [{ size: ["small", false, "large", "huge"] }],
      [{ align: [] }],
      ["bold", "italic", "underline"],
      [{ color: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
      ["clean"]
    ]
  };
  return (
    <div>
      <Grid container spacing={1} style={{ marginTop: "0px" }}>
        <Grid item xs={6}>
          <MySelect
            required
            label="Nhóm sản phẩm:"
            placeholder="Chọn..."
            value={values?.nhomSanPham}
            options={danhMucSanPhamList || []}
            name="tenDanhMuc"
            onChange={(event, value) => {
              setFieldValue(`nhomSanPham`, value);
            }}
            errors={errors?.nhomSanPham}
            helperText={errors?.nhomSanPham}
          />
        </Grid>
        <Grid item xs={6}>
          <FastField name="tenSanPham">
            {({ field }) => (
              <MyTextField
                required
                label="Tên sản phẩm:"
                placeholder="Nhập..."
                errors={errors?.tenSanPham}
                helperText={errors?.tenSanPham}
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FastField name="khoiLuongSanPham">
            {({ field }) => (
              <MyTextField
                label="Khối lượng sản phẩm:"
                placeholder="Nhập..."
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FastField name="donViTinh">
            {({ field }) => (
              <MyTextField
                label="Đơn vị tính:"
                placeholder="Nhập..."
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={12}>
          <FastField name="quyCachDongGoi">
            {({ field }) => (
              <MyTextField
                label="Quy cách đóng gói:"
                placeholder="Nhập..."
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FastField name="namDangKySuDung">
            {({ field }) => (
              <MyTextField
                type="number"
                label="Năm đăng ký sử dụng:"
                placeholder="Nhập..."
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FormControlLabel
            style={{ marginLeft: 0.5, alignItems: "center", marginTop: 20 }}
            control={
              <Switch
                checked={values?.tinhTrangHoatDong}
                onChange={(event, value) => {
                  setFieldValue("tinhTrangHoatDong", value);
                }}
              />
            }
            label="Tình trạng hoạt động"
          />
        </Grid>
        <Grid item xs={12}>
          <FastField name="ghiChu">
            {({ field }) => (
              <MyTextFieldArea
                label="Ghi chú:"
                placeholder="Nhập..."
                maxRows={3}
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={12}>
          <div
            style={{
              fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
              color: "#000000b3",
              fontSize: 15
            }}
          >
            Mô tả sản phẩm:
          </div>
          <ReactQuill
            value={values?.moTa}
            onChange={value => setFieldValue("moTa", value)}
            className="custom-quill"
            modules={modules}
            style={{
              maxHeight: "500px",
              overflowY: "auto",
              marginBottom: "8px"
            }}
          />
        </Grid>
        <Grid item xs={12} className="fileGiayChungNhan" style={{}}>
          <UploadAnhDaiDien
            multi={false}
            title="Ảnh đại diện sản phẩm:"
            titleBtnUpload="Tải lên ảnh"
            file={values?.hinhAnhDaiDiens || []}
            handleChangeFile={values =>
              setFieldValue(`hinhAnhDaiDiens`, values)
            }
            checkSave={false}
          />
        </Grid>
        <Grid item xs={12} className="fileGiayChungNhan">
          <UploadMultiHinhAnh
            multi={true}
            title="Các hình ảnh về sản phẩm:"
            file={values?.hinhAnhs || []}
            handleChangeFile={values => setFieldValue(`hinhAnhs`, values)}
            checkSave={false}
          />
        </Grid>
      </Grid>
    </div>
  );
};
